export type ParsedArticleUrl = {
  domain: string;
  cleanUrl: string;
  title: string;
};

export function parseSmartUrl(input: string, providedTitle = ''): ParsedArticleUrl {
  const trimmed = input.trim();
  const url = trimmed.startsWith('http://') || trimmed.startsWith('https://')
    ? new URL(trimmed)
    : new URL(`https://${trimmed}`);

  const domain = url.host.toLowerCase().replace(/^www\./, '');
  const slug = url.pathname.split('/').filter(Boolean).pop() ?? '';
  const fallbackTitle = slug
    .replace(/\.[a-z0-9]+$/i, '')
    .replace(/[-_]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (character) => character.toUpperCase());

  return {
    domain,
    cleanUrl: url.toString(),
    title: providedTitle.trim() || fallbackTitle || domain,
  };
}
